import * as React from 'react';
import classnames from 'classnames';

import Button from '@components/Button';
import { Dropdown } from '@components/Dropdown';
import { MultiLevelSearchDropdown } from '@components/Dropdown/MutliLevelSearchDropdown';
import { Select } from '@components/Input';

import './style.scss';

interface IRadioButtonProps {
  options: IRadioButtonOption[];
  value: any;
  name: string;
  onChange: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onFocus?: (e: any) => void;
  className?: string;
  disabled?: boolean;
  hideAfter?: number;
  primaryColor?: ButtonStyle;
  secondaryColor?: ButtonStyle;
  searchMode?: boolean;
  multiLevelSearch?: boolean;
  frequentAssigneesOptions?: any[];
  lastAssigneesOptions?: any[];
}

interface IRadioButtonState {}

export default class RadioButton extends React.Component<IRadioButtonProps, IRadioButtonState> {
  static defaultProps: Partial<IRadioButtonProps> = {
    className: '',
    disabled: false,
    primaryColor: ButtonStyle.PRIMARY,
    secondaryColor: ButtonStyle.DEFAULT,
    onFocus: () => null,
  };

  onChange = (value: any) => {
    const { name } = this.props;

    const fakeEvent: any = {
      currentTarget: {
        name,
        value,
      },
      target: {
        name,
        value,
      },
    };

    this.props.onChange(fakeEvent);
  };

  renderButtonOptions = (options: Array<{ value: any; label: string; disabled?: boolean }>) => {
    const { value, disabled, primaryColor, secondaryColor } = this.props;

    return (
      options &&
      options.map((option, index) => (
        <Button
          key={index}
          onClick={(e) => this.onChange(option.value)}
          onFocus={(e) => this.props.onFocus(e)}
          bsStyle={value === option.value ? primaryColor : secondaryColor}
          content={option.label}
          disabled={disabled || option?.disabled}
        />
      ))
    );
  };

  renderDropdownOptions = (options: Array<{ value: any; label: string }>) => {
    const {
      value,
      disabled,
      searchMode,
      multiLevelSearch,
      lastAssigneesOptions,
      options: allAssigneesOptions,
      name,
    } = this.props;
    const valueInOptions = options.findIndex((option) => option.value === value) > -1;

    const lastAssignees = lastAssigneesOptions
      ? lastAssigneesOptions.map((assignee) => ({
          name: `${assignee.label}`,
          value: {
            id: assignee.value,
            label: `${assignee.label}`,
            iconURL:
              // tslint:disable-next-line:max-line-length
              'https://cyberdyne-dev.s3.us-west-1.amazonaws.com/dev/agency_0/system_icon/animal.png?AWSAccessKeyId=AKIAXXACOQJHCAKGMVFF&Expires=1665975981&Signature=9rs4FQ8klWgfgcrKXkhSSUliKcA%3D',
          },
        }))
      : [];

    const allAssignees = allAssigneesOptions
      ? allAssigneesOptions.map((assignee) => ({
          name: `${assignee.label}`,
          value: {
            id: assignee.value,
            label: `${assignee.label}`,
            iconURL:
              // tslint:disable-next-line:max-line-length
              'https://cyberdyne-dev.s3.us-west-1.amazonaws.com/dev/agency_0/system_icon/animal.png?AWSAccessKeyId=AKIAXXACOQJHCAKGMVFF&Expires=1665975981&Signature=9rs4FQ8klWgfgcrKXkhSSUliKcA%3D',
          },
        }))
      : [];

    return options && options.length ? (
      searchMode ? (
        <Dropdown
          onChange={(e) => this.onChange(e.target.value)}
          placeholder="More..."
          value={value}
          disabled={disabled}
          options={options}
          onFocus={this.props.onFocus}
          name=""
          searchMode={true}
          searchPlaceholder="Search..."
          width="150px"
          className={classnames({
            'option-selected': valueInOptions,
          })}
        />
      ) : multiLevelSearch ? (
        <MultiLevelSearchDropdown
          onChange={(e) => this.onChange(e.target.value)}
          placeholder="More..."
          value={value}
          disabled={disabled}
          options={allAssignees}
          onFocus={this.props.onFocus}
          name={name}
          searchMode={true}
          searchPlaceholder="Search..."
          width="150px"
          className={classnames({
            'option-selected': valueInOptions,
          })}
          lastAssignees={lastAssignees}
          allAssignees={allAssignees}
        />
      ) : (
        <Select
          onChange={(e) => this.onChange(e.target.value)}
          placeholder="More..."
          value={value}
          disabled={disabled}
          options={options}
          onFocus={this.props.onFocus}
          name=""
        />
      )
    ) : null;
  };

  render() {
    const { options, className, hideAfter, frequentAssigneesOptions } = this.props;
    let buttonOptions;
    if (frequentAssigneesOptions && frequentAssigneesOptions.length > 0) {
      buttonOptions =
        frequentAssigneesOptions.length > hideAfter + 1
          ? frequentAssigneesOptions.slice(0, hideAfter)
          : frequentAssigneesOptions;
    } else {
      buttonOptions = options.length > hideAfter + 1 ? options.slice(0, hideAfter) : options;
    }

    const dropdownOptions = options.length > hideAfter + 1 ? options.slice(hideAfter) : [];

    return (
      <div className={classnames('multi-choice-buttons', className)}>
        {this.renderButtonOptions(buttonOptions)}
        {this.renderDropdownOptions(dropdownOptions)}
      </div>
    );
  }
}
